<form [formGroup]="locationForm">
  <mat-stepper class="stepper_upload_processing" #stepper>
    <mat-step label="{{'companies.basic_infos'|translate}}" class="static_steps">
      <div class="step_container">
        <div class="steps_block">
          <div class="step" [formGroup]="form">
            <div class="step_title">
              <span>
                {{"companies.basic_information" | translate}}
              </span>
            </div>
            <div class="content">
              <div class="field">
                <label for="">{{"companies.company_name" | translate}}</label>
                <input type="text" formControlName="name" [placeholder]="'companies.company_name'|translate">
                <span class="error_ms" *ngIf="form.get('name')?.touched && form.get('name')?.errors">
                  {{"common.required_field" | translate}}
                </span>
              </div>
              <div class="field">
                <label for="">{{"companies.companies_id"| translate}}</label>
                <input type="text" formControlName="company_id" [placeholder]="'companies.companies_id'|translate">
              </div>
            </div>
          </div>
          <div class="step">
            <div class="step_title inline_title">
              <div>
                <span>
                  {{"companies.documents_Files"|translate}}
                </span>
                <span class="descr_title">{{"companies.insert_documents_files_to_this_company" | translate}}</span>
              </div>
              <div>
                  <button class="add_btn " type="button" (click)="fileInput.click()">
                    <img src="assets/icones/add_icon.svg" alt="add_file">
                    <span>{{ "common.add" | translate }}</span>
                    <input
                      #fileInput
                      type="file"
                      (change)="onFileChange($event)"
                      multiple
                      style="display: none;"
                    />
                  </button>
              </div>
            </div>
            <span class="light_span"></span>
            <div class="content">
              <table class="listing_table">
                <tbody>
                  <ng-container *ngFor="let file of selectedFiles; let i = index">
                    <tr class="body_table_catalog">
                      <td class="td_block file_block">
                        <img src="../../../../../assets/icones/doc.svg" alt="">
                        <span class="file_name">{{ file.filename }}</span>
                        <span class="light_span"></span>
                      </td>
                      <td>
                        <button type="button" style="color: #404142" class="preview mg_left" (click)="preview(file.data, file.content_type)">
                          <mat-icon>visibility</mat-icon>
                        </button>
                        <button type="button" style="color: #404142; margin: 8px;" class="preview mg_left" (click)="download(file.data, file.filename, file.content_type)">
                          <mat-icon>download</mat-icon>
                        </button>
                        <button type="button" (click)="removeFile(i)">
                          <mat-icon style="color: #ADB5BD;">delete</mat-icon>
                        </button>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>

            </div>
          </div>
        </div>
        <div class="steps_block">
          <div class="step">
            <div class="step_title">
              <span>
                {{"companies.shipping" |translate}}
              </span>
            </div>
            <div class="body_step">
              <div class="content">
                <div class="step_title_inside">
                  <span class="sub_title">
                    {{"companies.shipping_address" |translate}}
                  </span>
                </div>
                <div class="content">
                    <div class="field">
                      <label for="">{{"common.location_name" | translate}}</label>
                      <input type="text" formControlName="name" [placeholder]="'common.location_name'|translate">
                      <span class="error_ms" *ngIf="locationForm.get('name')?.touched && locationForm.get('name')?.errors">
                        {{"common.required_field" | translate}}
                      </span>
                    </div>
                    <div class="field">
                      <label for="">{{"companies.location_address"| translate}}</label>
                      <input type="text" formControlName="apartment" [placeholder]="'companies.adress'|translate" id="apartment">
                      <span class="error_ms" *ngIf="locationForm.get('apartment')?.touched && locationForm.get('apartment')?.errors">
                        {{"common.required_field" | translate}}
                      </span>
                    </div>
                </div>
              </div>
              <div class="content">
                <div class="step_title_inside">
                  <span class="sub_title">
                    {{"companies.billing_address" |translate}}
                  </span>
                  <div class="inline_block slide_block">
                    <mat-slide-toggle formControlName="is_bill_same" (change)="toggleBillingAddress()">
                    </mat-slide-toggle>
                    <span>{{"companies.shopping_add" |translate}}</span>
                  </div>
                </div>
                <div class="content">
                    <div class="field">
                      <label for="">{{"companies.loc_adress" | translate}}</label>
                      <input type="text" formControlName="billing_apartment" [placeholder]="'companies.adress'|translate" [attr.disabled]="this.locationForm.get('is_bill_same')?.value === true ? 'true' : null"  id="billing_apartment">
                        <span class="error_ms" *ngIf="locationForm.get('billing_apartment')?.touched && locationForm.get('billing_apartment')?.errors">
                        {{"common.required_field" | translate}}
                      </span>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="submet_btns">
          <button type="button" class="save_btn_pop_up cancel_btn_pop_up" (click)="cancel()">
            <span>{{"common.back"|translate | uppercase}}</span>
            <img src="../../../../../assets/icones/arrow_back.svg" alt="">
        </button>
        <button type="button" class="save_btn_pop_up blue_btn" data-testid="customer-next-basic-infos" (click)="next('basic_infos')">
            <span>{{"common.next" | translate | uppercase}}</span>
            <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
        </button>
        </div>
      </div>
    </mat-step>
    <mat-step *ngIf="featureFlagService.traditionalContactsEnabled" label="{{'common.contact'|translate}}" class="static_steps">
      <div class="step_container">
        <div [formGroup]="mainContactForm" class="step">
          <div class="step_title">
            <span>
              {{"companies.main_contact" | translate}} ({{mainContacts.length}})
            </span>
          </div>
          <div class="locations" *ngFor="let contact of mainContacts let i = index">
            <span class="location_name">{{contact.contact_fname}}</span>
            <div class="open_location">
              <div class="open_location" (click)="openContact(contact, i)">
                <img [class]="expandedContactIndex === i ? 'arrow_down arrow_up' : 'arrow_down'" src="assets/icones/arrow_down.svg" alt="">
                <span class="open_variants">{{expandedContactIndex === i ? 'Hide' : 'Show' }}</span>
              </div>
              <button type="button" class="remove_btn" *ngIf="i !== 0" (click)="removeContact(i)" >
                <img src="assets/icones/red-removed.svg" alt="">
              </button>
            </div>
          </div>
          <div class="content">
            <div class="inline_block">
              <div class="field">
                <label for="">{{"companies.contact_first_name"| translate}}</label>
                <input type="text" formControlName="contact_fname" [placeholder]="'companies.contact_first_name'|translate">
                <span class="error_ms" *ngIf="hasAtLeastOneFieldFilled() && mainContactForm.get('contact_fname')?.touched && mainContactForm.get('contact_fname')?.errors">
                  {{"common.required_field" | translate}}
                </span>
              </div>
              <div class="field">
                <label for="">{{"companies.contact_last_name"|translate}}</label>
                <input type="text" formControlName="contact_lname" [placeholder]="'companies.contact_last_name'|translate">
              </div>
            </div>
            <div class="inline_block">
              <div class="field">
                <label for="">{{"common.email" | translate}}</label>
                <input type="text" formControlName="email" id="email" [placeholder]="'common.email'|translate">
                <span class="error_ms" *ngIf="hasAtLeastOneFieldFilled() && mainContactForm.get('email')?.touched && mainContactForm.get('email')?.errors?.['required']">
                  {{"common.required_field" | translate}}
                </span>
                <span class="error_ms"
                  *ngIf="hasAtLeastOneFieldFilled() && mainContactForm.get('email')?.touched && !mainContactForm.get('email')?.errors?.['required'] && mainContactForm.get('email')?.errors?.['invalidEmail']">Invalid
                  email format.</span>
                <span class="error_ms" *ngIf="mainContactForm.get('email')?.hasError('duplicateEmail')">
                  {{"companies.email_contact_already_exist" | translate}}
                </span>
              </div>
              <div class="field">
                <label for="">{{"companies.phone_number" | translate}}</label>
                <input type="text" formControlName="phone" [placeholder]="'companies.phone_number'|translate">
                  <span class="error_ms" *ngIf="mainContactForm.get('phone')?.touched && mainContactForm.get('phone')?.errors?.['numericOnly']">
            {{"validation.numeric_only" | translate}}
          </span>
              </div>
            </div>
            <div class="inline_block">
              <div class="field">
                <label for="">{{"settings.language" | translate}}</label>
                <select name="" id="" formControlName="lang">
                  <option selected disabled value="">{{"settings.language"|translate}}</option>
                  <option value="it_IT">{{"language.italian" | translate}}</option>
                  <option value="en_US">{{"language.english" | translate}}</option>
                  <option value="fr_FR">{{"language.french" | translate}}</option>
                </select>
                <span class="error_ms" *ngIf="hasAtLeastOneFieldFilled() && mainContactForm.get('lang')?.touched && mainContactForm.get('lang')?.errors">
                  {{"common.required_field" | translate}}
                </span>
              </div>
              <div class="field">
                <label for="">{{"common.signature" | translate}}</label>
                <input type="text" formControlName="signature" [placeholder]="'common.signature' | translate">
              </div>
            </div>
            <div class="inline_block slide_block">
              <mat-slide-toggle formControlName="is_user">
              </mat-slide-toggle>
              <span>{{"companies.invite_to_b2b_portal"|translate}}</span>

              <mat-slide-toggle [disabled]="true" formControlName="receive_emails">
              </mat-slide-toggle>
              <span>{{"companies.receive_emails"|translate}}</span>
            </div>
            <div class="btns">
              <button type="button" *ngIf="isContactUpdated" class="add_attr" (click)="updateContact()">
                <img src="../../../../../assets/icones/add_icon.svg" alt="">
                <span> {{"common.update"|translate}}</span>
              </button>
              <button type="button" *ngIf="!isContactUpdated" class="add_attr" (click)="saveContact()">
                <img src="../../../../../assets/icones/add_icon.svg" alt="">
                <span> {{"companies.save_contact" |translate}}</span>
              </button>
              <button type="button" *ngIf="!isContactUpdated" class="add_attr" (click)="addContact()">
                <img src="../../../../../assets/icones/add_icon.svg" alt="">
                <span> {{"companies.save_add_another_contact" | translate}}</span>
              </button>
            </div>
          </div>
        </div>
        <div class="submet_btns">
          <button type="button" class="save_btn_pop_up cancel_btn_pop_up" (click)="back()">
            <span>{{"common.back"|translate | uppercase}}</span>
            <img src="../../../../../assets/icones/arrow_back.svg" alt="">
          </button>
          <button type="button" class="save_btn_pop_up blue_btn" data-testid="customer-next-contacts" (click)="next('contacts')">
              <span>{{"common.next" |translate}}</span>
              <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
          </button>
        </div>
      </div>
    </mat-step>
    <mat-step label="{{'companies.invoicing'|translate}}" class="static_steps">
      <div class="step_container">
        <div class="step">
          <div class="step_title">
            <span>
              {{"companies.invoicing" | translate}}
            </span>
          </div>
          <div class="content">
            <div class="inline_block">
              <div class="field ">
                <label for="">{{"companies.payment_terms" | translate}}</label>
                <select name="" id="" formControlName="payment_terms">
                  <option selected disabled value="">{{"companies.payment_terms" | translate}}</option>
                  <option *ngFor="let paymentTerm of paymentTerms$ | async" [value]="paymentTerm.id">{{ paymentTerm.name  | translate}}</option>
                </select>
                <span class="error_ms" *ngIf="locationForm.get('payment_terms')?.touched && locationForm.get('payment_terms')?.errors">
                  {{"common.required_field" | translate}}
                </span>
              </div>
              <div class="field">
                <label for="">{{"companies.currency" |translate}}</label>
                <select name="" id="" formControlName="currency">
                  <option selected disabled value="">{{"companies.currency" |translate}}</option>
                  <option *ngFor="let currency of currencies$ | async" [value]="currency.id">{{currency.name}}</option>
                </select>
                <span class="error_ms" *ngIf="locationForm.get('currency')?.touched && locationForm.get('currency')?.errors">
                  {{"common.required_field" | translate}}
                </span>
              </div>
            </div>
            <div class="inline_block">
              <div class="field ">
                <label for="">{{"companies.tax_id" |translate}}</label>
                <input type="text" [placeholder]="'companies.tax_id'|translate" formControlName="tax_id">
              </div>
              <div class="field">
                <label for="">{{"companies.taxe" | translate}}</label>
                <select name="" id="" formControlName="tax">
                  <option selected disabled value="">{{"companies.taxe"|translate}}</option>
                  <option value="0">0%</option>
                  <option value="2.1">2,1%</option>
                  <option value="4">4%</option>
                  <option value="5.5">5,5%</option>
                  <option value="10">10%</option>
                  <option value="20">20%</option>
                  <option value="22">22%</option>
                </select>
                <span class="error_ms" *ngIf="locationForm.get('tax')?.touched && locationForm.get('tax')?.errors">
                  {{"common.required_field" | translate}}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="submet_btns">
          <button type="button" class="save_btn_pop_up cancel_btn_pop_up" (click)="back()">
            <span>{{"common.back"|translate | uppercase}}</span>
            <img src="../../../../../assets/icones/arrow_back.svg" alt="">
        </button>
        <button type="button" class="save_btn_pop_up blue_btn" data-testid="customer-next-invoicing" (click)="next('invoicing')">
            <span>{{"common.next" | translate | uppercase}}</span>
            <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
        </button>
        </div>
      </div>
    </mat-step>
    <mat-step label="{{'organize.organize'|translate}}" class="static_steps">
      <div class="step_container" *ngIf="currentForm==='addCustomer'">
        <div class="inline_block">
          <div class="step inline_step">
            <div class="step_title inline_title">
              <div>
                <span>
                  {{"Catalogs.catalogs" | translate}} ({{selectedCatalogs.length}})
                </span>
                <span class="descr_title">{{"companies.catalog_associated_with_this_location" | translate}}</span>
              </div>
              <button type="button" class="add_btn" (click)="goTo('insertCatalogs', 'organize')">
                <img src="assets/icones/add_icon.svg" alt="">
                <span>{{"common.add"|translate}}</span>
              </button>
            </div>
            <div class="content">
              <div *ngIf="!selectedCatalogs || selectedCatalogs.length === 0">
                {{"companies.contact_avaible" | translate}}.
              </div>
              <table class="listing_table" *ngIf="selectedCatalogs.length > 0">
                <tbody>
                  <ng-container *ngFor="let catalog of selectedCatalogs let i = index">
                    <tr class="body_table_catalog">
                      <td class="td_block">
                        <span class="bold_span">{{catalog.name}}</span>
                        <span class="light_span"></span>
                      </td>
                      <td>
                        <button type="button" (click)="removeCatalog(catalog.id)">
                          <mat-icon style="color: #ADB5BD;">delete</mat-icon>
                        </button>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </div>
          <div class="step inline_step" [formGroup]="locationForm">
            <div class="step_title inline_title">
              <div>
                <span>
                  {{"companies.custom_discount_rule" | translate}}
                </span>
              </div>
            </div>
            <div class="content">
              <div class="field">
                <label for="">{{"companies.price_discount_override"|translate}}</label>
                <select name="" id="" disabled>
                  <option selected value="" selected>Price decrease</option>
                </select>
              </div>
              <div class="field">
                <label for="">{{"companies.discount_value" | translate}}</label>
                <input type="number" [value]="this.locationForm.get('custom_discount')?.value" formControlName="custom_discount" (input)="onGeneralDiscountChange($event)">
                <span class="indicate_input indicate_input_custom">%</span>
              </div>
            </div>
          </div>
        </div>
        <div class="inline_block" [formGroup]="form">
          <div class="step inline_step">
            <div class="step_title">
              <span>
               {{"Catalogs.favorite" | translate}}
              </span>
            </div>
            <div class="content customers_chip">
              <div class="field">
                <label for="" class="label_list">
                  <img src="../../../../../assets/icones/brand.svg" alt="">
                  <span>{{"brands.brands"|translate}} ({{favorit_brands.length}})</span>
                </label>
                <mat-chip-list #chipList1>
                  <mat-chip *ngFor="let brand of favorit_brands" (removed)="cancelFavoritBrand(brand.id)">
                    {{brand.name}}
                    <button type="button" matChipRemove>
                      <mat-icon style="color: #ed8787;">remove_circle_outline</mat-icon>
                    </button>
                  </mat-chip>
                  <input class="input_chip" [placeholder]="'common.add'|translate" formControlName="brandControl"
                    [matAutocomplete]="auto1" [matChipInputFor]="chipList1"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [disabled]="!(brands$ | async)?.length">
                </mat-chip-list>
                <mat-autocomplete #auto1="matAutocomplete">
                  <mat-option *ngFor="let brand of filteredBrands$ | async" [value]="brand.name"
                    (click)="onFavoritBrandSelected(brand)">
                    {{brand.name}}
                  </mat-option>
                </mat-autocomplete>
                <p *ngIf="!(brands$ | async)?.length" class="no-groups-message">
                  {{"companies.no_brands_available" | translate}}
                </p>
              </div>
              <div class="field">
                <label for="" class="label_list">
                  <!-- <img src="../../../../../assets/icones/brand.svg" alt=""> -->
                  <span>{{"companies.black_listed_brands"| translate}} ({{blacklist_brands.length}})</span>
                </label>
                <mat-chip-list #chipList>
                  <mat-chip *ngFor="let brand of blacklist_brands" (removed)="cancelBlackListBrand(brand.id)">
                    {{brand.name}}
                    <button type="button" matChipRemove>
                      <mat-icon style="color: #ed8787;">remove_circle_outline</mat-icon>
                    </button>
                  </mat-chip>
                  <input class="input_chip" [placeholder]="'common.add'|translate" formControlName="brandControl"
                    [matAutocomplete]="auto2" [matChipInputFor]="chipList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [disabled]="!(brands$ | async)?.length">
                </mat-chip-list>
                <mat-autocomplete #auto2="matAutocomplete">
                  <mat-option *ngFor="let brand of filteredBrands$ | async" [value]="brand.name"
                    (click)="onBlackListBrandSelected(brand)">
                    {{brand.name}}
                  </mat-option>
                </mat-autocomplete>
              </div>
              <div class="field">
                <label for="" class="label_list">
                  <img src="../../../../../assets/icones/categories.svg" alt="">
                  <span>{{"Categories.categories" |translate}} ({{categories.length}})</span>
                </label>
                <mat-chip-list #chipList>
                  <mat-chip *ngFor="let category of categories" (removed)="cancelCategory(category.id)">
                    {{category.name}}
                    <button type="button" matChipRemove>
                      <mat-icon style="color: #ed8787;">remove_circle_outline</mat-icon>
                    </button>
                  </mat-chip>
                  <input class="input_chip" [placeholder]="'common.add'|translate" formControlName="categoryControl"
                    [matAutocomplete]="auto3" [matChipInputFor]="chipList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [disabled]="!(categories$ | async)?.length">
                </mat-chip-list>
                <mat-autocomplete #auto3="matAutocomplete">
                  <mat-option *ngFor="let category of filteredCategories$ | async" [value]="category.name"
                    (click)="onCategorySelected(category)">
                    {{category.name}}
                  </mat-option>
                </mat-autocomplete>
                <p *ngIf="!(categories$ | async)?.length" class="no-groups-message">
                  {{"companies.no_categories_available" | translate}}
                </p>
              </div>
              <div class="field">
                <label for="" class="label_list">
                  <img src="../../../../../assets/icones/tags.svg" alt="">
                  <span>
                    {{"Labels.labels"| translate }}({{tags.length}})
                  </span>
                </label>
                <mat-chip-list #chipList>
                  <mat-chip *ngFor="let tag of tags" (removed)="cancelTag(tag.id)">
                    {{tag.name}}
                    <button type="button" matChipRemove>
                      <mat-icon style="color: #ed8787;">remove_circle_outline</mat-icon>
                    </button>
                  </mat-chip>
                  <input class="input_chip" [placeholder]="'common.add'|translate" formControlName="tagControl"
                    [matAutocomplete]="auto4" [matChipInputFor]="chipList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [disabled]="!(tags$ | async)?.length">
                </mat-chip-list>
                <mat-autocomplete #auto4="matAutocomplete">
                  <mat-option *ngFor="let tag of filteredTags$ | async" [value]="tag.name"
                    (click)="onTagSelected(tag)">
                    {{tag.name}}
                  </mat-option>
                </mat-autocomplete>
                <p *ngIf="!(tags$ | async)?.length" class="no-groups-message">
                  {{"companies.no_labels_available" | translate}}
                </p>
              </div>
            </div>
          </div>
          <div class="step inline_step">
            <div class="step_title">
              <span>
                {{"companies.groups" | translate}}
              </span>
            </div>
            <div class="content customers_chip">
              <div class="field ">
                <label for="" class="label_list">
                  <img src="assets/icones/companies_groups.svg" alt="">
                  <span>{{"companies.groups" | translate}} ({{groupes.length}})</span>
                </label>
                <mat-chip-list #chipListG>
                  <mat-chip *ngFor="let groupe of groupes" (removed)="cancelGroupe(groupe.id)">
                    {{groupe.name}}
                    <button type="button" matChipRemove>
                      <mat-icon style="color: #ed8787;">remove_circle_outline</mat-icon>
                    </button>
                  </mat-chip>
                  <input class="input_chip" [placeholder]="'common.add'|translate" formControlName="groupeControl"
                    [matAutocomplete]="auto5" [matChipInputFor]="chipListG"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
                </mat-chip-list>
                <mat-autocomplete #auto5="matAutocomplete">
                  <mat-option *ngFor="let groupe of filteredGroupes$ | async" [value]="groupe.name"
                    (click)="onGroupeSelected(groupe)">
                    {{groupe.name}}
                  </mat-option>

                  <mat-option [value]="form.value.groupeControl" class="add_option"
                    *ngIf="!(filteredGroupes$ | async)?.length && form.value.groupeControl"
                    (click)="addNewElement(form.value.groupeControl, 'companies_groups.companies_groups')">
                    <img src="assets/icones/add.svg" alt="">
                    {{"common.add"|translate}} "{{ form.value.groupeControl }}"
                  </mat-option>
                </mat-autocomplete>
                <p *ngIf="!(groupes$ | async)?.length" class="no-groups-message">
                  {{"companies.no_groups_available" | translate}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="submet_btns">
          <button type="button" class="save_btn_pop_up cancel_btn_pop_up" (click)="back()">
            <span>{{"common.back"|translate | uppercase}}</span>
            <img src="../../../../../assets/icones/arrow_back.svg" alt="">
        </button>
        <button type="button" class="action_btn btn_edit" (click)="next()">
          <span>{{"companies.skip" | translate}}</span>
        </button>
        <button type="button" class="save_btn_pop_up blue_btn" data-testid="customer-next-summary" (click)="next()">
            <span>{{"companies.summary"|translate}}</span>
            <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
        </button>
        </div>
      </div>
      <app-inserting-catalogs
      *ngIf="currentForm==='insertCatalogs' && isnertStep === 'organize'"
      [selectedCatalogsO]="selectedCatalogs"
      [currentCustomDiscount]="currentCustomDiscount"
      [editCustom]="editCustom"
      (cancelCatalogs)="canceled()"
      (saveCatalogs)="onSaveCatalogs($event)"
      (saveCustomeDiscount)="saveCustomeDiscount($event)">
      </app-inserting-catalogs>
    </mat-step>
    <mat-step label="{{'common.summary'|translate}}" class="static_steps">
      <div class="step_container" *ngIf="currentForm==='addCustomer'">
        <div class="inline_block">
          <div class="step left_summary_step">
            <div class="step_title inline_title header_step">
              <div class="title_content">
                <span class="descr_title">
                  {{"companies.company_name"|translate}}
                </span>
                <span>{{this.form.value.name || form.get('name')?.value}}</span>
                <span class="small_black">ID : {{this.form.value.company_id || form.get('company_id')?.value }}</span>
              </div>
              <button type="button" *ngIf="!hideEditButton" class="add_btn" (click)="editBasicInfo()">
                <img src="../../../../../assets/icones/edit_catalog.svg" alt="">
                <span>{{"common.edit" | translate}}</span>
              </button>
            </div>
            <div class="step_title inline_title">
              <div class="title_content">
                <span class="descr_title">
                  {{"companies.shipping_address"|translate}}
                </span>
                <span>{{this.locationForm.value.apartment}}</span>
              </div>
              <button type="button" class="add_btn" (click)="editAddress()">
                <img src="../../../../../assets/icones/edit_catalog.svg" alt="">
                <span>{{"common.edit"|translate}}</span>
              </button>
            </div>
            <div class="step_title inline_title">
              <div>
                <span class="descr_title">
                  {{"companies.billing_address"|translate}}
                </span>
                <span *ngIf="!this.locationForm.value.is_bill_same">{{this.locationForm.value.billing_apartment}}</span>
                <span class="same_as" *ngIf="this.locationForm.value.is_bill_same">{{"Catalogs.same_as_shipping"|translate}}</span>
              </div>
            </div>
          </div>
          <div class="step right_summary_step">
            <div class="step_title inline_title">
              <div>
                <span>
                  {{"companies.documents_Files" | translate}}
                </span>
              </div>

              <button type="button" class="add_btn" (click)="editFiles(selectedFiles)">
                <img src="assets/icones/edit_catalog.svg" alt="">
                <span>{{ "common.edit" | translate }}</span>
              </button>

            </div>
            <div class="content">
              <table class="listing_table">
                <tbody>
                  <ng-container  *ngFor="let file of selectedFiles;; let i = index">
                    <tr class="body_table_catalog">
                      <td class="td_block file_block">
                        <img src="../../../../../assets/icones/doc.svg" alt="">
                        <span class="file_name">
                          {{file.filename}}
                        </span>
                        <span class="light_span"></span>
                      </td>
                      <td>
                        <button type="button" style="color: #404142" class="preview mg_left" (click)="preview(file.data, file.content_type)">
                          <mat-icon>visibility</mat-icon>
                        </button>
                        <button type="button" style="color: #404142; margin: 8px;" class="preview mg_left" (click)="download(file.data, file.filename, file.content_type)">
                          <mat-icon>download</mat-icon>
                        </button>
                        <button type="button" (click)="removeFile(i)">
                          <mat-icon style="color: #ADB5BD;">delete</mat-icon>
                        </button>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>

            </div>
          </div>
        </div>
        <div class="inline_block">
          <div class="step left_summary_step" *ngIf="featureFlagService.traditionalContactsEnabled">
            <div class="step_title inline_title">
              <div class="title_content">
                <span>{{"companies.main_contact"|translate}} {{mainContacts.length > 1 ? '+ ' + (mainContacts.length - 1) + 'more' : ''}}</span>
              </div>
              <button type="button" class="add_btn" (click)="editContacts()">
                <img src="../../../../../assets/icones/edit_catalog.svg" alt="">
                <span>{{"common.edit"|translate }}</span>
              </button>
            </div>
            <div *ngIf="!mainContacts || mainContacts.length === 0">
              {{"companies.no_contact_available"|translate}}
            </div>
            <div *ngIf="mainContacts && mainContacts.length > 0" class="step_title inline_title rigth_title">
              <div>
                <span class="descr_title">
                  {{"companies.contact_first_name" | translate}}
                </span>
                <span>{{mainContacts[0].contact_fname}}</span>
              </div>
              <div class="second_line">
                <span class="descr_title">
                  {{"companies.contact_last_name" | translate }}
                </span>
                <span>{{mainContacts[0].contact_lname}}</span>
              </div>
            </div>
            <div *ngIf="mainContacts && mainContacts.length > 0" class="step_title inline_title rigth_title">
              <div>
                <span class="descr_title">
                 {{"common.email"|translate}}
                </span>
                <span>{{mainContacts[0].email}}</span>
              </div>
              <div class="second_line">
                <span class="descr_title">
                  {{"common.phone"|translate}}
                </span>
                <span>{{mainContacts[0].phone}}</span>
              </div>
            </div>
            <div *ngIf="mainContacts && mainContacts.length > 0" class="step_title inline_title">
              <div style="display: flex; flex-direction: column;">
              <div>
                <span class="descr_title">
                  {{"companies.marketing_status" | translate}}       </span>
                <span>{{"companies.agreed_to_receive_marketing_emails" | translate}} : {{mainContacts[0].receive_emails}}</span><br>
                <span>{{"companies.agreed_to_receive_marketing_sms"|translate}} : N/A</span>
              </div>
              <div style="padding-top: 12px;">
                <span class="descr_title">
                  {{"common.signature"|translate}}</span>
                  <span>{{mainContacts[0].signature}}</span>
              </div>
              </div>
            </div>
          </div>
          <div class="step right_summary_step">
            <div class="step_title inline_title">
              <div>
                <span>
                 {{"companies.invoicing" | translate}}
                </span>
              </div>
              <button type="button" class="add_btn" (click)="editInvoicing()">
                <img src="../../../../../assets/icones/edit_catalog.svg" alt="">
                <span>{{"common.edit"|translate}}</span>
              </button>
            </div>
            <div class="step_title inline_title">
              <div>
                <span class="descr_title">
                  {{"companies.payment_taxes"|translate}}
                </span>
                <span>{{paymentTerm(this.locationForm.value.payment_terms)}}</span>
              </div>
            </div>
            <div class="step_title inline_title">
              <div>
                <span class="descr_title">
                  {{"Catalogs.currency"|translate}}
                </span>
                <span *ngIf="this.locationForm.value.currency">{{'(' +currency(this.locationForm.value.currency)?.symbol + ') ' + ' ' + currency(this.locationForm.value.currency)?.name}}</span>
              </div>
            </div>
            <div class="step_title inline_title">
              <div>
                <span class="descr_title">
                  {{"companies.tax_value"|translate}}
                </span>
                <span>{{this.locationForm.value.tax}} %</span>
              </div>
              <div class="second_line">
                <span class="descr_title">
                  {{"companies.tax_id"|translate}}
                </span>
                <span>{{this.locationForm.value.tax_id}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="inline_block media_block">
          <div class="step left_summary_step" [formGroup]="form">
            <div class="step_title">
              <span>
                {{"Catalogs.favorite"|translate}}
              </span>
            </div>
            <div class="content customers_chip">
              <mat-tab-group>
                <mat-tab>
                  <ng-template mat-tab-label>
                    <div class="title_block">
                      <img src="assets/icones/brand.svg" alt="">
                      {{"brands.brands"|translate}} ({{favorit_brands.length}})
                    </div>
                  </ng-template>
                  <div class="field field_favorit">
                    <mat-chip-list #chipList1>
                      <mat-chip *ngFor="let brand of favorit_brands" (removed)="cancelFavoritBrand(brand.id)">
                        {{brand.name}}
                        <button type="button" matChipRemove>
                          <mat-icon style="color: #ed8787;">remove_circle_outline</mat-icon>
                        </button>
                      </mat-chip>
                      <input class="input_chip" [placeholder]="'common.add'|translate" formControlName="brandControl"
                        [matAutocomplete]="auto1" [matChipInputFor]="chipList1"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [disabled]="!(brands$ | async)?.length">
                    </mat-chip-list>
                    <mat-autocomplete #auto1="matAutocomplete">
                      <mat-option *ngFor="let brand of filteredBrands$ | async" [value]="brand.name"
                        (click)="onFavoritBrandSelected(brand)">
                        {{brand.name}}
                      </mat-option>
                    </mat-autocomplete>
                    <p *ngIf="!(brands$ | async)?.length" class="no-groups-message">
                      {{"companies.no_brands_available" | translate}}
                    </p>
                  </div>
                </mat-tab>
                <mat-tab>
                  <ng-template mat-tab-label>
                    <div class="title_block">
                      <img src="assets/icones/brand.svg" alt="">
                      {{"companies.black_listed_brands"|translate}} ({{blacklist_brands.length}})
                    </div>
                  </ng-template>
                  <div class="field field_favorit">
                    <mat-chip-list #chipList>
                      <mat-chip *ngFor="let brand of blacklist_brands" (removed)="cancelBlackListBrand(brand.id)">
                        {{brand.name}}
                        <button type="button" matChipRemove>
                          <mat-icon style="color: #ed8787;">remove_circle_outline</mat-icon>
                        </button>
                      </mat-chip>
                      <input class="input_chip" [placeholder]="'common.add'|translate" formControlName="brandControl"
                        [matAutocomplete]="auto2" [matChipInputFor]="chipList"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [disabled]="!(brands$ | async)?.length">
                    </mat-chip-list>
                    <mat-autocomplete #auto2="matAutocomplete">
                      <mat-option *ngFor="let brand of filteredBrands$ | async" [value]="brand.name"
                        (click)="onBlackListBrandSelected(brand)">
                        {{brand.name}}
                      </mat-option>
                    </mat-autocomplete>

                  </div>
                </mat-tab>
                <mat-tab>
                  <ng-template mat-tab-label>
                    <div class="title_block">
                      <img src="assets/icones/categories.svg" alt="">
                      {{"Categories.categories"|translate}} ({{categories.length}})
                    </div>
                  </ng-template>
                  <div class="field field_favorit">
                    <mat-chip-list #chipList>
                      <mat-chip *ngFor="let category of categories" (removed)="cancelCategory(category.id)">
                        {{category.name}}
                        <button type="button" matChipRemove>
                          <mat-icon style="color: #ed8787;">remove_circle_outline</mat-icon>
                        </button>
                      </mat-chip>
                      <input class="input_chip" [placeholder]="'common.add'|translate" formControlName="categoryControl"
                        [matAutocomplete]="auto3" [matChipInputFor]="chipList"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [disabled]="!(categories$ | async)?.length">
                    </mat-chip-list>
                    <mat-autocomplete #auto3="matAutocomplete">
                      <mat-option *ngFor="let category of filteredCategories$ | async" [value]="category.name"
                        (click)="onCategorySelected(category)">
                        {{category.name}}
                      </mat-option>
                    </mat-autocomplete>
                    <p *ngIf="!(categories$ | async)?.length" class="no-groups-message">
                      {{"companies.no_categories_available" | translate}}
                    </p>
                  </div>
                </mat-tab>
                <mat-tab>
                  <ng-template mat-tab-label>
                    <div class="title_block">
                      <img src="assets/icones/tags.svg" alt="">
                      {{"Labels.labels"|translate}} ({{tags.length}})
                    </div>
                  </ng-template>
                  <div class="field field_favorit">
                    <mat-chip-list #chipList>
                      <mat-chip *ngFor="let tag of tags" (removed)="cancelTag(tag.id)">
                        {{tag.name}}
                        <button type="button" matChipRemove>
                          <mat-icon style="color: #ed8787;">remove_circle_outline</mat-icon>
                        </button>
                      </mat-chip>
                      <input class="input_chip" [placeholder]="'common.add'|translate" formControlName="tagControl"
                        [matAutocomplete]="auto4" [matChipInputFor]="chipList"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [disabled]="!(tags$ | async)?.length">
                    </mat-chip-list>
                    <mat-autocomplete #auto4="matAutocomplete">
                      <mat-option *ngFor="let tag of filteredTags$ | async" [value]="tag.name"
                        (click)="onTagSelected(tag)">
                        {{tag.name}}
                      </mat-option>
                    </mat-autocomplete>
                    <p *ngIf="!(tags$ | async)?.length" class="no-groups-message">
                      {{"companies.no_labels_available" | translate}}
                    </p>
                  </div>
                </mat-tab>
              </mat-tab-group>
            </div>
          </div>
          <div class="step right_summary_step" [formGroup]="locationForm">
            <div class="step_title inline_title">
              <div>
                <span>
                  {{"companies.custom_discount_rule"|translate}}
                </span>
              </div>
            </div>
            <div class="content">
              <div class="inline_block custom_block">
                <div class="field">
                  <label for="">{{"companies.price_discount_override" | translate }}</label>
                  <select name="" id="" disabled>
                    <option selected value="" selected>{{"Catalogs.price_descrease"|translate}}</option>
                  </select>
                </div>
                <div class="field category_field">
                  <input type="number" [value]="this.locationForm.get('custom_discount')?.value" formControlName="custom_discount" (input)="onGeneralDiscountChange($event)">
                  <span class="indicate_input custom_indic">%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="inline_block">
          <div class="step left_summary_step">
            <div class="step_title catalog_summary">
              <div class="title_block inside_block">
                <div class="title_block">
                  <img src="assets/icones/catalog.svg" alt="">
                  <span>
                    {{"Catalogs.catalogs"|translate}} ({{selectedCatalogs.length}})
                  </span>
                </div>
                <span class="descr_title">{{"companies.catalog_associated_with_this_location"|translate}}</span>
              </div>
              <button type="button" class="add_btn" (click)="goTo('insertCatalogs', 'summary')">
                <img src="assets/icones/add_icon.svg" alt="">
                <span>{{"common.add"|translate}}</span>
              </button>
            </div>
            <div class="content">
              <div *ngIf="!selectedCatalogs || selectedCatalogs.length === 0">
                {{"companies.no_catalogs_available"|translate}}
              </div>
              <table class="listing_table" *ngIf="selectedCatalogs.length > 0">
                <thead class="header_stiky">
                  <tr class="head_table">
                    <th>{{"companies.catalog_title"|translate}}</th>
                    <th>{{"common.wholesale_discount"|translate}}</th>
                    <th>{{"common.custom_discount"|translate}}</th>
                    <th>{{"Catalogs.total_discount"|translate}}</th>
                    <th>{{"quotations_and_orders.product"|translate}}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let catalog of selectedCatalogs let i = index">
                    <tr class="body_table">
                      <td class="td_block">
                        <span class="bold_span">{{ catalog.name }}</span> <br>
                      </td>
                      <td class="td_block">
                        <span class="bold_span">{{ catalog.general_discount ?  "-"+catalog.general_discount+"%" : "N/A"}}</span>
                      </td>
                      <td>
                        <span class="descr_elemnt">
                          {{catalog.additional_discount ? "-"+catalog.additional_discount+"%" : 'N/A' }}
                          </span>
                      </td>
                      <td>
                        {{sumDiscount(catalog.general_discount!, catalog.additional_discount!) ? "-" +sumDiscount(catalog.general_discount!, catalog.additional_discount!)+"%" : 'N/A' }}
                      </td>
                      <td>
                        {{ catalog.nbr_products }}
                      </td>
                      <td>
                        <button type="button" (click)="removeCatalog(catalog.id)">
                          <mat-icon style="color: #ADB5BD;">delete</mat-icon>
                        </button>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </div>
          <div class="step right_summary_step" [formGroup]="form">
            <div class="step_title">
              <span>
                {{"companies.groups"|translate}}
              </span>
            </div>
            <div class="content customers_chip">
              <mat-tab-group>
                <mat-tab>
                  <ng-template mat-tab-label>
                    <div class="title_block">
                      {{"companies.groups"|translate}} ({{groupes.length}})
                    </div>
                  </ng-template>
                  <div class="field field_favorit">
                    <mat-chip-list #chipList1>
                      <mat-chip *ngFor="let groupe of groupes" (removed)="cancelGroupe(groupe.id)">
                        {{groupe.name}}
                        <button type="button" matChipRemove>
                          <mat-icon style="color: #ed8787;">remove_circle_outline</mat-icon>
                        </button>
                      </mat-chip>
                      <input class="input_chip" [placeholder]="'common.add'|translate" formControlName="groupeControl"
                        [matAutocomplete]="auto5" [matChipInputFor]="chipList1"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
                    </mat-chip-list>
                    <mat-autocomplete #auto5="matAutocomplete">
                      <mat-option *ngFor="let groupe of filteredGroupes$ | async" [value]="groupe.name"
                        (click)="onGroupeSelected(groupe)">
                        {{groupe.name}}
                      </mat-option>

                      <mat-option [value]="form.value.groupeControl" class="add_option"
                        *ngIf="!(filteredGroupes$ | async)?.length && form.value.groupeControl"
                        (click)="addNewElement(form.value.groupeControl, 'companies_groups.companies_groups')">
                        <img src="assets/icones/add.svg" alt="">
                        {{"common.add"|translate}} "{{ form.value.groupeControl }}"
                      </mat-option>
                    </mat-autocomplete>
                    <p *ngIf="!(groupes$ | async)?.length" class="no-groups-message">
                      {{"companies.no_groups_available" | translate}}
                    </p>
                  </div>
                </mat-tab>
              </mat-tab-group>
            </div>
          </div>
        </div>
        <div class="submet_btns">
          <button type="button" class="save_btn_pop_up cancel_btn_pop_up" (click)="back()">
            <span>{{"common.back"|translate | uppercase}}</span>
            <img src="../../../../../assets/icones/arrow_back.svg" alt="">
          </button>
          <button type="button" class="save_btn_pop_up green_btn" data-testid="customer-save-btn" (click)="save()">
              <span>{{"common.save"|translate | uppercase}}</span>
              <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
          </button>
        </div>
      </div>
      <app-inserting-catalogs
      *ngIf="currentForm==='insertCatalogs' && isnertStep === 'summary'"
      [selectedCatalogsO]="selectedCatalogs"
      [currentCustomDiscount]="currentCustomDiscount"
      [editCustom]="editCustom"
      (cancelCatalogs)="canceled()"
      (saveCatalogs)="onSaveCatalogs($event)"
      (saveCustomeDiscount)="saveCustomeDiscount($event)">
      </app-inserting-catalogs>
    </mat-step>
  </mat-stepper>
</form>
